export default __webpack_public_path__ + "static/media/julian_s.ed4d23a7.jpg";